import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import SessionTableHeader from './SessionTableHeader';
import SessionTableRow from './SessionTableRow';
import { addNewSession } from '../../data/fileImport/sessionsActions';

const SessionTable = props => {
  const sessionRows = props.sessions.map((session, i) => {
    return <SessionTableRow key={i} session={session} fileTypes={props.fileTypes} />;
  });

  return (
    <Table celled className="striped table sessions__table">
      <SessionTableHeader fileTypes={props.fileTypes} />

      <Table.Body>{sessionRows}</Table.Body>

      <Table.Footer fullWidth>
        <Table.Row>
          <Table.Cell colSpan={2}>
            <Button
              className="button-add-session transparent"
              onClick={event => props.dispatch(addNewSession(props.project.id))}
            >
              <i className="icon-add-line icon" /> <span>Add Session</span>
            </Button>
          </Table.Cell>
          <Table.Cell colSpan={1000}> </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

SessionTable.propTypes = {
  sessions: PropTypes.array,
  fileTypes: PropTypes.array,
  project: PropTypes.object
};

export default connect()(SessionTable);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/SessionTable.js